import React from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import FormInputText from "../../../../../components/form/FormInputText";
import FormInputNumber from "../../../../../components/form/FormInputNumber";
import FormInputBooleanSwitch from "../../../../../components/form/FormInputBooleanSwitch";
// INTERFACES
import { MakeGroupInterface } from "../../../../../../interfaces/AdapterCdoOpc.interface";

export default function ComponentMakeGroup({
  data,
  setData,
}: {
  data: MakeGroupInterface;
  setData: (newValue: MakeGroupInterface) => void;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onChangeValue = (newValue: string | number | boolean, variableName: string) => {
    const copy = structuredClone(data);
    if (variableName === "name" && typeof newValue === "string") {
      copy.group.name = newValue;
    } else if (variableName === "update_rate" && typeof newValue === "number") {
      copy.group.update_rate = newValue;
    } else if (variableName === "revised_update_rate" && typeof newValue === "number") {
      copy.group.revised_update_rate = newValue;
    } else if (variableName === "dead_band" && typeof newValue === "number") {
      copy.group.dead_band = newValue;
    } else if (variableName === "active" && typeof newValue === "boolean") {
      copy.group.active = newValue;
    }
    setData(copy);
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <FormInputText
        inputValue={data.group.name}
        inputLabelName={t("general.name")}
        inputOnChange={onChangeValue}
        inputVariableName="name"
        isRequired
        disabledInput={false}
      />
      <FormInputNumber
        inputValue={data.group.update_rate}
        inputLabelName={t("general.updateRate")}
        inputOnChange={onChangeValue}
        inputVariableName="update_rate"
      />
      <FormInputNumber
        inputValue={data.group.revised_update_rate}
        inputLabelName={t("general.revisedUpdateRate")}
        inputOnChange={onChangeValue}
        inputVariableName="revised_update_rate"
      />
      <FormInputNumber
        inputValue={data.group.dead_band}
        inputLabelName={t("general.deadBand")}
        inputOnChange={onChangeValue}
        inputVariableName="dead_band"
      />
      <FormInputBooleanSwitch
        value={data.group.active}
        onChangeSwitch={onChangeValue}
        labelName={t("general.active")}
        variableName="active"
        isRequired
        disabledInput={false}
      />
    </div>
  );
}
